<template>
  <div class='container'>

    <img class='title' src="../assets/image/title.png" alt="" />

    <div class="text1" v-if="language === 'TC'">
      NIKE步態掃描服務解析您獨一無二的步態找到最適合您的NIKE跑鞋
    </div>
    <div class="text2" v-else>
      NIKE Foot Scan Test analyzes your unique foot pattern to find the most suitable NIKE running shoes for you.
    </div>


    <div class='bottom-box'>
      <img v-if="language === 'TC'" @click="toIndex" class='web btn' src="../assets/image/tc/btn_browser.png" alt="">
      <img v-else @click="toIndex" class='web btn' src="../assets/image/en/btn_browser.png" alt="">
      <img v-if="language === 'TC'" @click="lineLogin" class='line btn' src="../assets/image/tc/btn_line.png" alt="">
      <img v-else @click="lineLogin" class='line btn' src="../assets/image/en/btn_line.png" alt="">
    </div>

   
  </div>

</template>

<script>
  import axios from 'axios'

  export default {
    data () {
      return {
        loading: false,
      }
    },
    mounted() {
      let language = localStorage.getItem('language')
      if (language) {
        this.$store.commit('set_language', language)
      }

      if (liff.isLoggedIn()) {
        this.$router.replace({ path: "/index" })
      }
    },
    methods:{
      toIndex() {
        this.$router.replace({ path: "/index" })
      },

      lineLogin() {
        if (!liff.isInClient()) {
          liff.init({
            liffId: '1656184654-SjsXGPT7'
          }).then(() => {
            if (!liff.isLoggedIn()) {
              liff.login({
                redirectUri: window.location.href
              });
            } else {
              liff.getProfile().then((profile) => {
                this.$store.commit('set_openid', profile.userId)
                this.$router.replace({ path: "/index" })

                if (!this.$store.state.timestamp) {
                  this.$store.commit('set_timestamp', this.getParameterByName('t'))
                }
                console.log('profile :>> ', profile);
              }).catch((err) => {
                console.log('liff getProfile failed', err)
              })
            }
            
          }).catch((err) => {
            console.log('liff initialization failed', err)
          })
          return
        }

        this.$router.replace({ path: "/index" })
      },

      getParameterByName(name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '))
      }
    },


    computed: {
      language() {
        return this.$store.state.language
      },
      timestamp() {
        return this.$store.state.timestamp
      },
      openid() {
        return this.$store.state.openid
      },
      baseUrl() {
        return this.$store.state.baseUrl
      },
    },

  }
</script>


<style lang="less" scoped>
  .title {
    position: absolute;
    top: 50vw;
    left: 8vw;
    width: 84vw;
  }

  .text1 {
    position: absolute;
    top: 70vw;
    left: 12.8vw;
    width: 74.6vw;
    font-size: 4vw;
    line-height: 6vw;
    font-weight: 500;
    text-align: center;
    font-family: 'en-bold';
    // font-family: 'fs-regular';
  }

  .text2 {
    position: absolute;
    top: 70vw;
    left: 8vw;
    width: 84vw;
    font-size: 3.8vw;
    line-height: 6vw;
    font-weight: 500;
    text-align: center;
    font-family: 'en-bold';
  }

  .bottom-box {
    position: absolute;
    width: 100%;
    left: 0;
    bottom: 8vw;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .web {
      width: 87.2vw;
      margin-bottom: 5vw;
    }
    .line {
      width: 87.2vw;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/login.vue